import React from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";

import "./i18n";
import App from "./App";
import { initSentryForProdVyprvpn } from "./utils/sentry";

initSentryForProdVyprvpn();

const tagManagerArgs = {
  gtmId: "GTM-N6WV53J",
};

TagManager.initialize(tagManagerArgs);

createRoot(document.getElementById("root") as HTMLElement).render(<App />);
// test comment
